import {useFeatureFlags} from '@smart/feature-app';
import {Heading} from '@smart/web-components';
import type {Maybe} from 'graphql/jsutils/Maybe';
import React from 'react';
import {UsedFeatureFlags} from '../../constants/common';
import SubheaderArea from './SubheaderArea';
import styles from './index.module.scss';

type HeaderAreaTypes = {
  newHeadline: string;
  subHeadline?: string;
  uniqueSellingPoints?: string | readonly Maybe<string>[];
};

const HeaderArea = ({
  newHeadline,
  subHeadline,
  uniqueSellingPoints,
}: HeaderAreaTypes): JSX.Element => {
  const baseClass = `headerArea`;
  const {enabled: enableFilters} = useFeatureFlags(
    UsedFeatureFlags.ENABLE_STOCK_SEARCH_FILTER_V2,
  );

  return (
    <section className={styles[baseClass]}>
      <Heading
        className={styles[`${baseClass}__heading`]}
        variant={enableFilters ? `D-200` : `display-functional-200`}
      >
        {newHeadline}
      </Heading>
      {enableFilters && subHeadline && (
        <div className={styles[`${baseClass}__subTitle`]}>{subHeadline}</div>
      )}

      {Array.isArray(uniqueSellingPoints) &&
        uniqueSellingPoints?.length >= 1 && (
          <SubheaderArea uniqueSellingPoints={uniqueSellingPoints} />
        )}
    </section>
  );
};

export default HeaderArea;
